<template>
  <PageCard
    pageName="Technology Analytics"
    :iconClass="['cuis-file-code', 'card-icon-font']"
    :showHeader="false"
  >
    <template slot="page_content">
      <div
        :class="
          partnerSite ? ['homepage-content partner-site'] : ['homepage-content']
        "
      >
        <section class=" solution-section">
          <div class="">
            <div class="section container-margin" id="1">
              <div class="ps-2">
                <div class="row card-row">
                  <div class="col-9">
                    <h1 class="card-title d-inline-block pr-3 banner-title">
                      Technology Analytics
                    </h1>
                    <div class="solution-icon same-col soln-img"></div>
                  </div>
                </div>
                <p class="card-text mb-4 soln-desc">
                  Navigate Digital Transformation with Confidence
                </p>
              </div>
              <FeatureDetailsCard
                title="FinTech Market Reports"
                description1="Quickly assess market share or client firmographics by vendor or vendor-product."
                description2="Client firmographics allow users to identify vendor-product client bases that most resemble their own institution."
                description3="The solution is ideal for vendor evaluation, competitive intelligence and the evolution of your technology strategy."
                button1Text="See Use Cases"
                button1Link="#usecases"
                :galleryImages="FI_SOL_FIN_M"
              />
              <FeatureDetailsCard
                title="FIN VendorFit"
                description1="Leverage FIN VendorFit to rank core processing vendor-product fit for any FI. The regression integrates over 100 variables ranging from asset size to technology purchase behavior."
                description2="Gauge vendor-product fit with presentation-ready graphics covering size, market, strategy, performance, productivity, & technologies to  identify your best fit for core processing."
                button1Text="See Use Cases"
                button1Link="#usecases"
                :galleryImages="FI_SOL_FIN_V"
              />
            </div>
          </div>
        </section>
        <FiUseCaseDetails></FiUseCaseDetails>
      </div>
    </template>
  </PageCard>
</template>

<script>
// global
import { mapState } from 'vuex'
// layout
import PageCard from '@/modules/core/components/layouts/PageCard'
import FeatureDetailsCard from '../components/layouts/FeatureDetailsCard'
import FiUseCaseDetails from './FiUseCaseDetails.vue'
// import FI_SOL_FIN_M1 from '../../../../static/img/solutionImages/FI_SOL_FIN_M1.png'
// import FI_SOL_FIN_M2 from '../../../../static/img/solutionImages/FI_SOL_FIN_M2.png'
// import FI_SOL_FIN_M3 from '../../../../static/img/solutionImages/FI_SOL_FIN_M3.png'
// import FI_SOL_FIN_M4 from '../../../../static/img/solutionImages/FI_SOL_FIN_M4.png'
// import FI_SOL_FIN_V1 from '../../../../static/img/solutionImages/FI_SOL_FIN_V1.png'
// import FI_SOL_FIN_V2 from '../../../../static/img/solutionImages/FI_SOL_FIN_V2.png'
// import FI_SOL_FIN_V3 from '../../../../static/img/solutionImages/FI_SOL_FIN_V3.png'
// import FI_SOL_FIN_V4 from '../../../../static/img/solutionImages/FI_SOL_FIN_V4.png'
// import FI_SOL_FIN_V5 from '../../../../static/img/solutionImages/FI_SOL_FIN_V5.png'
// import FI_SOL_FIN_V6 from '../../../../static/img/solutionImages/FI_SOL_FIN_V6.png'
// import FI_SOL_FIN_V7 from '../../../../static/img/solutionImages/FI_SOL_FIN_V7.png'

export default {
  name: 'AboutTechnologyAnalytics',
  components: {
    PageCard,
    FeatureDetailsCard,
    FiUseCaseDetails
  },
  data() {
    return {
      FI_SOL_FIN_M: [
        process.env.VUE_APP_IMG_CLOUDFRONT_URL + '/FI_SOL_FIN_M1.png',
        process.env.VUE_APP_IMG_CLOUDFRONT_URL + '/FI_SOL_FIN_M2.png',
        process.env.VUE_APP_IMG_CLOUDFRONT_URL + '/FI_SOL_FIN_M3.png',
        process.env.VUE_APP_IMG_CLOUDFRONT_URL + '/FI_SOL_FIN_M4.png'
      ],
      FI_SOL_FIN_V: [
        process.env.VUE_APP_IMG_CLOUDFRONT_URL + '/FI_SOL_FIN_V1.png',
        process.env.VUE_APP_IMG_CLOUDFRONT_URL + '/FI_SOL_FIN_V2.png',
        process.env.VUE_APP_IMG_CLOUDFRONT_URL + '/FI_SOL_FIN_V3.png',
        process.env.VUE_APP_IMG_CLOUDFRONT_URL + '/FI_SOL_FIN_V4.png',
        process.env.VUE_APP_IMG_CLOUDFRONT_URL + '/FI_SOL_FIN_V5.png',
        process.env.VUE_APP_IMG_CLOUDFRONT_URL + '/FI_SOL_FIN_V6.png',
        process.env.VUE_APP_IMG_CLOUDFRONT_URL + '/FI_SOL_FIN_V7.png'
      ]
    }
  },
  created() {
    document.title = 'Technology Analytics'
  },
  computed: {
    ...mapState({
      partnerSite: state => state.partnerSite
    })
  }
}
</script>

<style lang="scss" src="../scss/infoCards.scss"></style>
<style lang="scss" scoped>
.solution-section {
  .soln-img {
    background: url('../../../../static/img/FI_TA.png');
    background-size: cover;
    // margin-bottom: 10px;
  }
}
</style>
